import React, {useState, useEffect} from "react";
import Menu from "../../../../../components/layout/menu/index";
import CreateFormScreen from "../../../../../components/forms/createFormScreen";
import UserDataStep from "../../../../../components/forms/createFormScreen/userDataStep";
import { useNavigate, useLocation } from "react-router-dom";

const CategoryTabs = ({ categories, activeTab, onTabChange, disabledTabs }) => {

  return (
    <div className="flex overflow-y-auto">
      {categories.map((category, index) => {
        const isDisabled = disabledTabs.includes(category);

        return (
        <button
          key={index}
            className={`py-[17px] px-8 border-b-[3px] rounded-tl-xl rounded-tr-xl border-blue font-itcmedium text-base md:text-lg ${
              activeTab === category
                ? 'bg-blue text-white'
                : isDisabled 
                  ? 'text-gray-400 bg-gray-100 cursor-not-allowed'
                  : 'text-blue bg-white hover:bg-blue-50'
            }`}
            onClick={() => {
              if (!isDisabled) {
                  onTabChange(category);
                }
            }}
            disabled={isDisabled}
         
        >
          {category}
        </button>
        );

      })}
    </div>
  );
};

export default function CreateSurvey() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navigate = useNavigate();
  const location = useLocation();

  const [activeCategoryTab, setActiveCategoryTab] = useState("Encuestas");
  const criteria = ["Encuestas", "Envío"];

  const [savedFormData, setSavedFormData] = useState(null);
  const [createdSurveyId, setCreatedSurveyId] = useState(null); 

  const duplicateData = location.state?.duplicateSurveyData;
  const isDuplicating = location.state?.isDuplicating;
  const originalTitle = location.state?.originalSurveyTitle;

  useEffect(() => {
    if (duplicateData) {
      setActiveCategoryTab("Encuestas");
    }
  }, [duplicateData]);

  const getDisabledTabs = () => {
    const disabledTabs = [];
    
    if (!savedFormData || !createdSurveyId) {
      disabledTabs.push("Envío");
    }
    
    if (activeCategoryTab === "Envío") {
      disabledTabs.push("Encuestas");
    }
    
    return disabledTabs;
  };

  const handleFormSaved = (formData, surveyId) => {
    setSavedFormData(formData);
    setCreatedSurveyId(surveyId); 
    setActiveCategoryTab("Envío"); 
  };

  const handleFormSent = () => {
    navigate("/encuestas");
  };

  const handleBackToSurveys = () => {
    navigate("/encuestas");
  };

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%] flex flex-col gap-4">
                <CategoryTabs 
                    categories={criteria} 
                    activeTab={activeCategoryTab}
                    onTabChange={setActiveCategoryTab}
                    savedFormData={savedFormData} 
                    disabledTabs={getDisabledTabs()}
                />

                {activeCategoryTab === "Encuestas" && (
                    <CreateFormScreen 
                        onBack={handleBackToSurveys}
                        onFormSaved={handleFormSaved} 
                        duplicateData={duplicateData} 
                        isDuplicating={isDuplicating}
                        originalTitle={originalTitle}
                    />
                )}

                {activeCategoryTab === "Envío" && (
                    <>
                    {savedFormData && createdSurveyId && (

                        <UserDataStep
                          savedFormData={savedFormData}
                          surveyId={createdSurveyId}
                          onBack={() => {
                            setSavedFormData(null);
                            setCreatedSurveyId(null);
                            navigate("/encuestas"); 
                          }}
                          onFormSent={handleFormSent}
                          mode="create"
                        />
                    )}
                    </>
                )}
            </div>
        </div>
    </div>
  );
}